import type { FutureConfig } from 'react-router-dom';

export const routerFutureFlags: Partial<FutureConfig> = {
  v7_startTransition: false,
  v7_relativeSplatPath: true,
};
